// a library to wrap and simplify api calls
import apisauce from 'apisauce'
import Constants from './Constants'


class Api {
    constructor() {

        this.createNonAuthEndpoint = (baseURL) => apisauce.create({
            // base URL is read from the "constructor"
            baseURL: baseURL + '/',

            // here are some default headers
            headers: {
                'Cache-Control': 'no-cache'
            },
            // 100 second timeout...
            timeout: 10000
        })


        this.createAuthEndpoint = (baseURL) => apisauce.create({
            // base URL is read from the "constructor"
            baseURL: baseURL + '/api/',
            // here are some default headers
            headers: {
                'Cache-Control': 'no-cache'
            },
            // 100 second timeout...
            timeout: 100000
        })

        this.createUploadEndpoint = (baseURL) => apisauce.create({
            // base URL is read from the "constructor"
            baseURL: baseURL + '/api/',
            // here are some default headers
            headers: {
                'Cache-Control': 'no-cache',
                'Content-Type': 'multipart/form-data'
            },
            // 100 second timeout...
            timeout: 100000
        })

        this.createS3UploadEndpoint = (baseURL = Constants.s3URL) => apisauce.create({
            baseURL: baseURL,

            headers: {
                'Content-Type': 'multipart/form-data'
            },

            timeout: 160000

        })

        this.createOpenEndpoint = () => apisauce.create({
            baseURL: '',

            headers: {},

            timeout: 160000

        })

        this.initialize = (baseURL) => {
            this.apiClientNonAuth = this.createNonAuthEndpoint(baseURL)
            this.apiClientAuth = this.createAuthEndpoint(baseURL)
            this.apiUploadAuth = this.createUploadEndpoint(baseURL)
            this.apis3upload = this.createS3UploadEndpoint()
            this.apiOpenEndPoint = this.createOpenEndpoint()
        }

        this.makeACall = credentials => this.apiClientAuth.post('v1/publish', credentials)

        this.addUser = (params) => this.apiClientAuth.post('v2/user', params)
        this.updateUser = (params) => this.apiClientAuth.put('v2/1/user', params)
        this.updateSimilarStudents = (params) => this.apiClientAuth.put('v2/similar/students', params)

        this.addUserCommunityIfDoesNotExist = (params) => this.apiClientAuth.post('v2/user/organization/community/ifNotExist', params)

        this.userLogin = (credentials, transform) => this.apiClientNonAuth.post('login/parent', credentials)
        // this.magicLinkLogin = (config) => this.apiClientNonAuth.get(`login/magic-link/${config.magicLink}/type/${config.type || 'email'}`, null)
        this.magicLinkLogin = (config) => this.apiClientNonAuth.get(`login/magic-link/${config.magicLink}`, null)
        this.invitationLinkLogin = (config) => this.apiClientNonAuth.get(`login/invitation-link/${config.invitationLink}`, null)

        this.socialMediaLogin = (credentials) => this.apiClientAuth.post('v2/login/social-media', credentials)

        this.sendOtp = (params) => this.apiClientAuth.post('v3/otp', params)
        this.getUser = (config) => this.apiClientAuth.get('v2/user', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        this.sendOtpPhone = (params) => this.apiClientAuth.post('v2/otp', {username: params.username, length: 4, userRegistered: params.isRegistered})
        this.verifyUnRegisteredOtp = (params) => this.apiClientAuth.post('v2/unregistered/otp', params)
        
        this.verifyOtp = (params) => this.apiClientNonAuth.post('login', params)
        
        this.getZones = (config) => this.apiClientAuth.get('v2/zones', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getCity = (config) => this.apiClientAuth.get('v2/city', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getDistrict = (config) => this.apiClientAuth.get('v2/district', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getStates = (config) => this.apiClientAuth.get('v2/states', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getGlossary = () => this.apiClientAuth.get('v2/glossary', null)
        this.getCountry = () => this.apiClientAuth.get('v2/country', null)
        this.getPartners = () => this.apiClientAuth.get('v2/partners', null)
        this.getSpecialities = () => this.apiClientAuth.get('v2/speciality', null)
        this.getGlossary = () => this.apiClientAuth.get('v2/glossary', null)
        this.getOffers = () => this.apiClientAuth.get('v2/offers', null)

        this.getVaccination = () => this.apiClientAuth.get('v2/vaccination', null)

        this.getAvailability = (params) => this.apiClientAuth.post('v2/parent/activation', params)
        this.postUserLocation = (location) => this.apiClientAuth.post(`v2/user/location`, location)
        this.getAvailabilityWithoutDOB = (params) => this.apiClientAuth.post('v2/2/parent/activation/withoutdob', params)
        // this.getAvailabilityWithoutDOB = (params) => this.apiClientAuth.post('v2/parent/activation/withoutdob', params)
        this.fetchUserSignUpStatus = (params) => this.apiClientAuth.get(`v2/2/parent/sighup/status/${params}`, null)
        this.fetchUserSignUpStatusV3 = (params) => this.apiClientAuth.get(`v3/parent/sighup/status/${params}`, null)

        this.getUserAssociation = (param) => this.apiClientAuth.get('v2/user/association', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.putUserAssociation = (param) => this.apiClientAuth.put('v2/user/association', param)

        this.postUserLinkedInCredentials = (param) => this.apiClientAuth.post('v2/user/linkedIn/AuthCode', param)

        this.getParentStudentAssociation = (param) => this.apiClientAuth.get('v2/parent/student/association', null, { headers: { 'X-SELECT': JSON.stringify(param) } })

        this.postUserInvitationAssociation = (params) => this.apiClientAuth.post('v2/user/invitation/association', params)

        this.postUserAssociationUsingActivationCOde = (params) => this.apiClientAuth.post('v2/parent/association', params)
        this.postUserAssociationUsingActivationCodeWithoutDOB = (params) => this.apiClientAuth.post('v2/parent/association/withoutdob',params)

        this.fetchOrganizationList = (param) => this.apiClientAuth.get('v2/organization', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addOrganization = (param) => this.apiClientAuth.post('v2/organization', param)
        this.editOrganization = (id, payload) => this.apiClientAuth.put('v2/organization/'+id, payload)
        this.getOrganization = (param) => this.apiClientAuth.get('v2/organization/'+param)
        
        this.fetchQCList = (param) => this.apiClientAuth.get('v2/events', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.fetchQCDetail = (param) => this.apiClientAuth.get(`v2/event/${param.startNode}/metriclist`, null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.editQCRemarks = (param, metricId) => this.apiClientAuth.put(`v2/event/${metricId}/metric`, param)

        this.fetchStudentList = param => this.apiClientAuth.get('v2/user/search', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.fetchStudentListCount = param => this.apiClientAuth.get('v2/user/search/count', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.fetchStudentDataOMR = param => this.apiClientAuth.get('v2/download/omr', null, { headers: { 'X-SELECT': JSON.stringify(param) } })

        this.fetchMetricManifest = () => this.apiClientAuth.get('v2/omr')
        this.fetchStudentAssessmentDetails = params => this.apiClientAuth.get('v2/event/' + params.urlParam + '/metric', null, { headers: {'X-SELECT': JSON.stringify(params.headerParam)} })
        this.updateStudentAssessmentDetails = params => this.apiClientAuth.put('v2/event/' + params.urlParam + '/metric', params.payload)

        this.fetchStudentAssessmentHistory = params => this.apiClientAuth.get('v2/student/startNodes', null, { headers: {'X-SELECT': JSON.stringify(params)} })

        this.fetchStudentAssessmentStatus = params => this.apiClientAuth.get('v2/2/student/assessmentStatus', null, { headers: {'X-SELECT': JSON.stringify(params)} })

        this.fetchDMFTIndex =  params => this.apiClientAuth.get('v2/student/dentalDmft', null, { headers: {'X-SELECT': JSON.stringify(params)} })

        this.fetchPentahoReport = params => this.apiClientAuth.get('v2/report/student/' + params.reportName, null, { headers: {'X-SELECT': JSON.stringify(params.reportParams)} })
        this.fetchPentahoReportPDF = params => this.apiClientAuth.get('v2/report/student/' + params.reportName + '/pdf', null, { headers: {'X-SELECT': JSON.stringify(params.reportParams)} })

        this.postExpertQueries = params => this.apiClientAuth.post('v2/log/queries', params)

        this.postRequestAppointment = params => this.apiClientAuth.post('v2/log/requestappointments', params)

        this.fetchProgramList = (param) => this.apiClientAuth.get('v2/program', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addProgram = (param) => this.apiClientAuth.post('v2/program', param)
        this.editProgram = (param) => this.apiClientAuth.put('v2/program', param)
        this.getProgram = (param) => this.apiClientAuth.get(`v2/program/${param}`, null)

        this.updateEventTrack = (trackId, payload) => this.apiClientAuth.put(`v2/event/${trackId}`, payload)

        this.getContentNode = (param) => this.apiClientAuth.get('v2/content', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addContentNode = (param) => this.apiClientAuth.post('v2/content', param)
        this.editContentNode = (param) => this.apiClientAuth.put('v2/content', param)

        this.getContentAssociation = (param) => this.apiClientAuth.get('v2/content/association', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addContentAssociation = (param) => this.apiClientAuth.post('v2/content/association', param)
        this.editContentAssociation = (param) => this.apiClientAuth.put('v2/content/association', param)

        this.getS3Creds = (config) => this.apiClientAuth.get('s3/uploadaccess', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.uploadToS3 = (form, options) => this.apis3upload.post('/', form, options)
        this.uploadUser = (payload) => this.apiClientAuth.post('v2/upload/user', { userRecord: JSON.stringify({ users: payload }) })
        this.uploadOmr = (payload, event_track_id) => this.apiClientAuth.put(`v2/upload/omr/${event_track_id}`, { omrJson: JSON.stringify(payload) })

        this.postCovidDeclarationForm = (payload) => this.apiClientAuth.post('v2/covid/declaration', payload)
        this.getCovidDeclarationList = (param) => this.apiClientAuth.get('v2/covid/declaration/user/declaration/list', null, { headers: { 'X-SELECT': JSON.stringify(param) } })

        this.putInvitationRequestSuccess = (params) => this.apiClientAuth.put(`v2/user/invitation`, { invitationLink: params.link, status: params.status || 3 })

        this.postInvitationRequest = (config) => this.apiClientAuth.post(`v2/user/invitation`, config)

        this.getCovidDeclarationOverallSymptomsV2 = (config) => this.apiClientAuth.get('v2/2/covid/declaration/overall/symptoms', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        this.getOpenAPI = (url) => this.apiOpenEndPoint.get(`https://cors.healthsetgo.com/${url}`)

        this.getCovidGlobalDashboardInd = () => this.apiOpenEndPoint.get('https://data.covid19india.org/v4/min/data.min.json')
        this.getCovidGoogleRSSFeed = (limit, start) => this.apiOpenEndPoint.get(`https://cors.healthsetgo.com/https://news.google.com/news?q=covid-19&hl=en-US&sort=date&gl=IN&start=${start}&num=${limit}&output=rss`)
        
        this.setToken = (token) => {
            this.apiClientAuth.setHeader('Authorization', 'Bearer ' + token.jwt)
            this.apiUploadAuth.setHeader('Authorization', 'Bearer ' + token.jwt)
        }

    }

}

// let's return back our create method as the default.
export default new Api()
